import { get, post } from '@/utils'
export interface IPaymantBreakdownPayload {
  senderAddress: string
  receiverAddress: string
}
class Giftcard {
  GetAll = () => get('/gift-card')
  Claim = (code: string) => post('/gift-card/claim', { code })
}
export const GiftcardService = new Giftcard()
